import React from 'react';

function Privacy() {
  return (
    <div style={{ maxWidth: 900, margin: '40px auto', padding: '32px', background: '#fff', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.04)' }}>
      <h1 style={{ fontSize: '2rem', marginBottom: '24px' }}>개인정보처리방침</h1>
      <div style={{ whiteSpace: 'pre-line', fontSize: '1.05rem', color: '#222', lineHeight: 1.8 }}>
{`주식회사리마는 개인정보와 관련된 법규를 준수하며, 이용자들의 개인정보를 소중히 다루고 있습니다.
주식회사 리마(이하 '회사')은 개인정보와 관련된 법규를 준수하며, 이용자들의 개인정보를 소중히 다루고 있습니다. 회사는 정보통신망 이용촉진 및 정보보호에 관한 법률, 개인정보보호법 등 관련 법령과 동법 시행규칙을 준수합니다. 정보주체의 개인정보를 보호하고 고충을 원활하고 신속하게 처리할 수 있도록 개인정보가 어떠한 목적과 방법으로 이용되고 있으며, 개인정보보호를 위해 어떠한 조치가 취해지고 있는지 알려드립니다. 개인정보처리방침을 개정하는 경우 웹사이트 공지사항을 통하여 공지 하겠습니다.

제 1조 개인정보의 수집 및 이용목적
가.   회사는 다음의 목적을 위하여 개인정보를 처리합니다.
§  고객문의처리
‐          고객문의사항 확인
‐          처리결과 통보
§  프로모션 및 마케팅 활용 (마케팅 정보 수신 동의자에 한함)
‐          리소스 자료 다운로드
‐          뉴스레터 및 프로모션 신청 및 피드백 제공
‐          이벤트/행사 참가등록 및 피드백 제공
‐          행사설문조사
§  서비스 이용 시 생성되는 정보
‐          서비스 이용 통계

나. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다.
다. 회사는 정보주체에게 재화나 서비스를 홍보하거나 판매를 권유하기 위하여 개인정보의 처리에 대한 동의를 받으려는 때에는 고객이 이를 명확하게 인지할 수 있도록 알리고 동의를 받습니다.
라. 회사는 전자적 전송매체를 이용하여 영리목적의 광고성 정보를 전송하는 경우 수신자의 명시적인 사전동의를 받고 있으며, 2년마다 정기적으로 수신자의 수신동의 여부를 확인하고 있습니다. 또한 수신자가 수신거부의사를 표시하거나 사전동의를 철회한 경우 영리목적의 광고성 정보전송을 중단하고 있습니다.

제 2조 개인정보 수집항목
가. 회사는 개인정보의 수집 및 이용목적, 법령에 근거한 처리를 위해 필요한 최소한의 개인정보만 수집합니다. 
§  고객문의처리
‐          필수: 이름, 이메일
‐          선택: 연락처
§  프로모션 및 마케팅 활용
‐          필수: 이름, 이메일, 연락처, 회사명, 직책
‐          선택: 관심분야, 담당영업대표, 등록경로
§  서비스 이용 시 생성되는 정보
‐          필수:  IP Address, 방문 일시, 서비스 이용 기록

나. 회사는 정보주체의 기본적 인권을 침해할 우려가 있는 민감한 정보(인종, 종교, 사상, 정치적 성향 및 범죄 기록, 건강 상태 등)는 수집하지 않습니다.
다. 정보주체가 선택 정보를 입력하지 않은 경우에도 서비스 이용제한은 없습니다.
라. 정보주체는 프로모션 및 마케팅 활용 동의를 거부할 권리가 있습니다.

제 3조 개인정보 수집방법
회사는 다음과 같은 방법으로 개인정보를 수집합니다.

§  고객문의처리 : 홈페이지, 전화, 이메일, 팩스 
§  프로모션 및 마케팅 활용: 홈페이지, 서면 
§  서비스 이용 시 생성되는 정보: 홈페이지 이용과정에서 자동으로 생성되어 수집

제 4조 개인정보의 처리 및 보유기간
회사는 법령에 따른 개인정보 보유·이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의받은 개인정보 보유·이용 기간 내에서 개인정보를 처리·보유합니다.

§  고객문의처리 : 수집, 이용에 관한 동의일로부터 2년까지, 정보주체의 동의 철회 시 까지
§  프로모션 및 마케팅 활용:  수집, 이용에 관한 동의일로부터 2년까지, 정보주체의 동의 철회 시 까지 
§  서비스 이용 시 생성되는 정보: 수집, 이용에 관한 동의일로부터 3개월까지

제 5조 개인정보의 제3자 제공
회사는 개인정보를 개인정보의 수집 및 이용목적에서 고지한 범위 내에서 사용하며, 이용자의 사전 동의 없이 동 범위를 초과하여 이용하거나 이용자의 개인정보를 외부에 제공하지 않습니다. 단, 기타 법령에 의거하여 적법한 절차에 의한 정부나 수사기관의 요구가 있는 경우는 예외로 합니다.

§  제공받는자 : ZINFI
‐          개인정보 항목: 이름, 이메일, 연락처, 회사명, 직책
‐          이용목적 : GS ITM 서비스 및 프로모션 ,이벤트 안내
‐          보유기간: 수집 후 1년 

제 6조 개인정보처리의 위탁
원칙적으로 이용자의 동의 없이 해당 개인정보의 처리를 위탁하지 않습니다. 다만, 회사는 원활하고 향상된 고객서비스를 위하여 개인정보를 제한된 범위에서 타 업체에게 위탁하여 관리하도록 할 수 있습니다. 위탁 계약 시, 관계 법령에 따라 위탁대상자, 위탁업무내용, 위탁기간, 위탁계약 내용(개인정보보호관련 법규의 준수, 개인정보에 관한 제3자 제공 금지 및 책임부담 등을 규정) 및 개인정보의 안전한 관리에 대한 사항을 공지사항 및 개인정보처리방침을 통해 고지하며, 필요한 경우 사전 동의를 받도록 하겠습니다.

제 7조 정보주체의 권리, 의무 및 그 행사방법
가. 정보주체 및 만 14세 미만 아동의 법정대리인은 언제든지 회사에 대해 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다.
1. 개인정보 열람 요구: 회사에서 보유하고 있는 개인정보는 열람을 요구할 수 있습니다. 다만 개인정보 열람 요구는 다음과 같이 제한될 수 있습니다.
§  법률에 따라 열람이 금지되거나 제한되는 경우
§  다른 사람의 생명/신체를 해할 우려가 있거나, 다른 사람의 재산과 그 밖의 이익을 부당하게 침해할 우려가 있는 경우
2. 개인정보 정정/삭제 요구: 회사에서 보유하고 있는 개인정보에 대해서는 개인정보 정정/삭제를 요구할 수 있습니다.
3. 개인정보 처리 정지 요구: 회사에서 보유하고 있는 개인정보에 대해서는 회사에 개인정보의 처리 정지를 요구할 수 있습니다.
나. 가.항에 따른 권리 행사는 개인정보 보호책임자 및 담당부서를 통해 서면, 전자우편, 모사전송(FAX) 등으로 하실 수 있으며 회사는 이에 대해 지체 없이 조치하겠습니다.
다. 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다.
라. 가.항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있으나, 위임장을 제출하셔야 합니다.
마. 정보주체는 개인정보 보호법 등 관계법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.

제 8조 개인정보 자동수집 장치의 설치, 운영 및 거부
회사는 이용자의 정보를 수시로 저장하고 찾아내는 '쿠키(cookie)' 등을 운용합니다. 쿠키란 회사의 웹사이트를 운영하는데 이용되는 서버가 귀하의 브라우저에 보내는 아주 작은 텍스트 파일로서 이용자의 컴퓨터 하드디스크에 저장됩니다. 회사는 다음과 같은 목적을 위해 쿠키를 사용합니다.
1. 쿠키 등 사용 목적
§  접속 빈도나 방문 시간 등을 분석, 이용자의 취향과 관심분야를 파악 및 자취 추적, 각종 이벤트 참여 정도 및 방문 회수 파악 등을 통한 타겟 마케팅 및 개인 맞춤 서비스 제공
2. 쿠키 설정 거부 방법
§  귀하는 쿠키 설치에 대한 선택권을 가지고 있습니다.  다만 쿠키 설치를 거부하였을 경우 서비스 제공에 어려움이 있을 수 있습니다.
§  쿠키 설정을 거부하는 방법으로는 사용하시는 웹 브라우저의 옵션을 선택함으로써 모든 쿠키를 허용하거나, 쿠키를 저장할 때마다 확인을 거치거나, 모든 쿠키의 저장을 거부할 수 있습니다.
§  설정방법 예 (인터넷 익스플로어의 경우)
웹 브라우저 상단의 도구 > 인터넷 옵션 > 개인정보

제 9조 개인정보의 안전성 확보 조치
회사는 수집한 개인정보의 안전성 확보를 위해 다음과 같은 조치를 취하고 있습니다.

1. 관리적 조치: 내부관리계획 수립/시행, 정기적 직원 교육 등
2. 기술적 조치: 개인정보처리시스템 등의 접근권한 관리, 고유식별정보 등의 암호화, 보안프로그램 설치 등
3. 물리적 조치: 전산실, 자료 보관실 등의 접근통제

제 10조 개인정보의 파기
가. 회사는 개인정보 수집목적의 달성, 보유기간의 경과, 정보주체의 삭제요청 시 지체 없이 해당 개인정보를 파기합니다
나. 가.항의 경우에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 최소한의 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. 이 경우에도 법령에서 정한 목적 범위 내에서만 처리하도록 관리합니다.
다. 개인정보 파기의 절차 및 방법은 다음과 같습니다.
1. 파기절차
§  회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기 합니다.
2. 파기방법
§  회사는 전자적 파일 형태로 기록/저장된 개인정보는 기록을 재생할 수 없도록 파기하며, 종이 문서에 기록/저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.

제 11조 개인정보 보호책임자 및 관리자
정보주체는 회사의 서비스를 이용하면서 발생한 모든 개인정보 보호 관련 문의, 불만처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의할 수 있습니다. 회사는 정보주체의 문의에 대해 지체 없이 답변 및 처리 하겠습니다.
§  개인정보보호책임자
‐          담당부서:CISO
‐          성명: 오수근
‐          이메일: bruce@rimahr.com
‐          연락처: 02-6959-9280
§  개인정보보호관리자
‐          담당부서:보안사업팀
‐          성명: 오수근
‐          이메일: bruce@rimahr.com 
‐          연락처: 02-6959-9280

제 12조 개인정보 분쟁해결
정보주체는 개인정보침해로 인한 구제를 받기 위하여 아래의 기관에 분쟁해결이나 상담 등을 신청할 수 있습니다.
1. 개인정보 침해신고센터 (한국인터넷진흥원 운영)
§  소관업무: 개인정보 침해사실 신고, 상담 신청
§  홈페이지: privacy.kisa.or.kr/
§  전화: (국번없이) 118
§  주소: (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터
2. 개인정보 분쟁조정위원회
§  소관업무: 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결)
§  홈페이지: www.kopico.go.kr
§  전화: (국번없이) 1833-6972
§  주소: (03171) 서울특별시 종로구 세종대로 209 정부서울청사 4층
3. 대검찰청 사이버범죄수사단: (국번없이) 1301, cid@spo.go.kr (http://www.spo.go.kr)
4. 경찰청 사이버안전국: (국번없이) 182 ( cyberbureau.police.go.kr)

제 13조 이메일 무단수집 거부
회사는 게시된 이메일주소가 전자우편 수집 프로그램이나 그 밖의 기술적 장치를 이용하여 무단 수집되는 것을 거부합니다. 이를 위반 시 『정보통신망 이용 촉진 및 정보보호 등에 관한 법률』 등에 의해 처벌받을 수 있습니다.    

제 14조 고지의 의무
현 개인정보처리방침 내용 추가, 삭제 및 수정이 있을 시에는 회사는 홈페이지의 팝업창 또는 ‘공지사항’을 통해 사전 고지할 것입니다.

제 15조 개인정보 처리방침의 변경
가. 이 개인정보 처리방침은  2025.03.20 부터 적용됩니다.
나. 이전의 개인정보 처리방침은 아래에서 확인하실 수 있습니다. 
`}
      </div>
    </div>
  );
}

export default Privacy